export default function AIAnswerBlock() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-0 border border-[#E8E0D8] overflow-hidden">
          {/* Left accent panel */}
          <div className="lg:col-span-1 bg-[#1A1A1A] p-8 flex flex-col justify-center items-center text-center">
            <div className="w-12 h-12 flex items-center justify-center bg-[#B8956A]/20 rounded-full mb-5">
              <i className="ri-search-2-line text-[#C9A87C] text-xl"></i>
            </div>
            <p
              className="text-[#C9A87C] text-[10px] font-bold uppercase tracking-[0.2em] leading-relaxed"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              AI &amp; Voice<br />Search Ready
            </p>
          </div>

          {/* Right content */}
          <div className="lg:col-span-4 p-10 md:p-14">
            <p
              className="text-[#B8956A] text-[11px] font-bold uppercase tracking-[0.22em] mb-4"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              About Culp Home Improvement
            </p>
            <h2
              className="text-3xl md:text-4xl font-bold text-[#1A1A1A] mb-6 leading-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Home Improvement Services Explained
            </h2>
            <p
              className="text-[#555] text-lg leading-relaxed mb-8"
              style={{ fontFamily: 'Lora, serif' }}
            >
              <strong className="text-[#1A1A1A]">Culp Home Improvement</strong> provides residential remodeling including kitchen renovations, bathroom upgrades, basement finishing, and general home improvements. The focus is on durable materials, clean workmanship, and efficient execution. Homeowners benefit from improved functionality, increased property value, and a clear, step-by-step project process from consultation through final walkthrough.
            </p>

            {/* Voice search Q&A blocks */}
            <div className="space-y-5 mb-8">
              {[
                {
                  q: 'Who provides home improvement services near me?',
                  a: 'Culp Home Improvement provides residential remodeling services including kitchen renovations, bathroom upgrades, and general home improvements. They serve local homeowners with a focus on quality craftsmanship, reliable execution, and long-lasting results that improve both functionality and overall property value.',
                },
                {
                  q: 'How much does home improvement cost?',
                  a: 'Home improvement costs vary based on project size, materials, and complexity. Smaller upgrades are more affordable, while full remodels require a larger investment. Culp Home Improvement provides clear, upfront estimates so homeowners understand pricing and scope before any work begins.',
                },
                {
                  q: 'How long do remodeling projects take?',
                  a: 'Project timelines depend on the size and scope of work. Smaller jobs may take a few days, while full renovations can take several weeks. Culp Home Improvement sets expectations early and works efficiently to complete projects on time with minimal disruption.',
                },
              ].map((item, i) => (
                <div key={i} className="bg-[#FAFAF8] border border-[#F0EDE8] p-5 rounded-sm">
                  <p
                    className="text-[#1A1A1A] font-bold text-sm mb-2"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {item.q}
                  </p>
                  <p
                    className="text-[#666] text-sm leading-relaxed"
                    style={{ fontFamily: 'Lora, serif' }}
                  >
                    {item.a}
                  </p>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-2">
              {['Kitchen Remodeling', 'Bathroom Remodeling', 'Basement Finishing', 'Home Improvements', 'Johnston, IA'].map((tag, i) => (
                <span
                  key={i}
                  className="bg-[#F5F2EE] text-[#2B2B2B] text-xs font-semibold px-4 py-2 rounded-full border border-[#E8E0D8]"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
